<template>
<div class="sidebar">
  <div class="sidebar-scroll">
    <!-- Lista de salas -->
    <div
      v-for="(sala, index) in salas"
      :key="(sala && sala.id) ? sala.id : ('tmp-' + index)"
      :class="['sidebar-item', (sala && sala.id) === salaSelecionada ? 'active' : '']"
      @click="sala && sala.id && $emit('salaSelecionada', sala.id)"
    >
      <div class="avatar" :class="{ 'avatar-notificacao': sala.temMensagemNova && sala.id !== salaSelecionada }">
        <!-- Conversa direta com foto -->
        <img
          v-if="isConversaDireta(sala) && getFotoOutroUsuario(sala)"
          :src="getFotoOutroUsuario(sala)"
          alt="Avatar"
        />

        <!-- Conversa direta sem foto -->
        <span v-else-if="isConversaDireta(sala)"><img src="../../assets/img/user-icon.png" alt=""></span>

        <!-- Grupo -->
        <span v-else id="grupo"><img src="../../assets/img/user-groups.png" alt=""></span>
      </div>
      <!-- <span class="nome-scroll" @mouseleave="resetarScroll($event)">{{ getNomeSala(sala) }}</span> -->
      <div class="nome-e-badge">
        <span class="nome-scroll" @mouseleave="resetarScroll($event)">
          {{ getNomeSala(sala) }}
        </span>
      </div>
    </div>
  </div>

    <div class="sidebar-footer">
      <!-- Linhas únicas -->
      <div class="d-grid gap-2 mb-2">
        <button class="btn btn-sm btn-outline-blue w-100" @click="$emit('criarSala')">
          {{ $t('chatApp.criarSala') }}
        </button>
        <button class="btn btn-sm btn-outline-blue w-100" @click="$emit('iniciarConversa')">
          {{ $t('chatApp.novaConversa') }}
        </button>
      </div>

      <!-- Linha com 2 colunas -->
      <div class="row g-2">
        <div class="col-6">
          <button
            class="btn btn-sm btn-outline-blue w-100"
            :disabled="!podeEditarSala"
            @click="$emit('editarSala', salaSelecionadaCompleta)"
          >
            {{ $t('chatApp.editarSala') }}
          </button>
        </div>
        <div class="col-6">
          <button
            class="btn btn-sm btn-outline-danger w-100"
            :disabled="!podeExcluirSala"
            @click="$emit('excluirSala', salaSelecionadaCompleta)"
          >
            {{ $t('chatApp.excluirSala') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    usuarioId: Number,
    salaSelecionada: Number,
    salas: Array,
  },
  data() {
    return {
      // <<< inicializa o cache aqui
      displayNameCache: Object.create(null),
    };
  },
  watch: {
    salas: {
      handler(novas) {
        if (!Array.isArray(novas)) return;
        for (const sala of novas) {
          const id = sala?.id;
          if (id == null) continue;
          const nomeExplicito = (sala?.nome || '').trim();
          if (nomeExplicito && nomeExplicito.toLowerCase() !== 'chatroom__1:1') {
            this.displayNameCache[id] = nomeExplicito;
            continue;
          }
          const outro = this.isConversaDireta(sala)
            ? sala?.assinantes?.find(a => !a?.assinanteURI?.endsWith(`/${this.usuarioId}`))
            : null;
          if (outro?.nome?.trim()) {
            this.displayNameCache[id] = outro.nome.trim();
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    salaSelecionadaCompleta() {
      return this.salas.find(s => s.id === this.salaSelecionada);
    },
    souMembroAtivo() {
      const sala = this.salaSelecionadaCompleta
      if (!sala?.assinantes) return false
      return sala.assinantes.some(a => a.assinanteURI?.endsWith(`/${this.usuarioId}`))
    },
    podeEditarSala() {
      const sala = this.salaSelecionadaCompleta;
      return !!sala && !this.isConversaDireta(sala) && this.souMembroAtivo;
    },
    podeExcluirSala() {
      const sala = this.salaSelecionadaCompleta;
      // regra simples: precisa ter uma sala selecionada
      return !!sala;
    }
  },
  methods: {
    isNomePlaceholder(sala) {
      const nome = (sala?.nome || '').trim().toLowerCase()
      return nome === 'chatroom__1:1'.toLowerCase()
    },
    isConversaDireta(sala) {
      const tem2 = Array.isArray(sala?.assinantes) && sala.assinantes.length === 2
      const ePlaceholder = this.isNomePlaceholder(sala)
      const contemUsuarioAtual = tem2 && sala.assinantes.some(a => a?.assinanteURI?.endsWith(`/${this.usuarioId}`))
      return tem2 && ePlaceholder && contemUsuarioAtual
    },
    getFotoOutroUsuario(sala) {
      const outro = sala.assinantes.find(a => !a.assinanteURI.endsWith(`/${this.usuarioId}`))
      return outro?.foto || null
    },
    getNomeSala(sala) {
      if (!sala) return 'Sala #—';
      const id = sala.id;

      // 0) Se já temos cache para esta sala, use (evita "Sala #-")
      const cached = id != null ? this.displayNameCache[id] : null;

      // 1) Conversa direta (com o usuário atual ainda na sala)
      if (this.isConversaDireta(sala)) {
        const outro = sala?.assinantes?.find(a => !a?.assinanteURI?.endsWith(`/${this.usuarioId}`));
        if (outro?.nome?.trim()) {
          const nome = outro.nome.trim();
          if (id != null) this.displayNameCache[id] = nome;
          return nome;
        }
      }

      // 2) Nome explícito da sala (grupos ou diretas renomeadas)
      const nome = (sala?.nome || '').trim()
      if (nome && nome.toLowerCase() !== 'chatroom__1:1') {
        if (id != null) this.displayNameCache[id] = nome;
        return nome
      }

      // 3) Fallbacks quando você já saiu / dados incompletos
      const candidato = sala?.assinantes?.[0]?.nome
      if (candidato?.trim()) {
        const v = candidato.trim();
        if (id != null) this.displayNameCache[id] = v;
        return v;
      }

      // 4) Último recurso:
      //    - Se temos cache: mantém o último nome bom (evita "Sala #-")
      //    - Senão, cai para identificador técnico
      if (cached) return cached;
      const ident = id != null ? `Sala #${id}` : 'Sala #—';
      if (id != null) this.displayNameCache[id] = ident; // memoriza algo estável
      return ident;
    },
    resetarScroll() {
      // no-op seguro + implementação útil
      this.$nextTick(() => {
        const el = this.$refs?.listaSalas || this.$el?.querySelector?.('.lista-salas');
        if (el && typeof el.scrollTop === 'number') {
          el.scrollTop = 0; // ou outro comportamento desejado
        }
      });
    },
  }
}
</script>

<style scoped>
.sidebar {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;  /* ocupa todo o espaço vertical da coluna */
  min-height: 0;   /* ESSENCIAL para liberar o overflow nos filhos */
  overflow: hidden;/* sem scroll aqui; a lista rola */
  padding: 0;
}

.sidebar-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 15px;
  color: #333;
}

.sidebar-item:hover {
  background-color: #f0f0f0;
}

.sidebar-item.active {
  background-color: var(--sec-color);
  color: white;
}

.sidebar-scroll {
  flex: 1 1 auto;  /* a lista cresce e pode encolher */
  min-height: 0;   /* ESSENCIAL */
  overflow-y: auto;/* aqui é onde aparece a barra de rolagem */
  padding: 8px;
}

.sidebar-footer {
  flex: 0 0 auto;
  padding: 8px;
  border-top: 1px solid #ddd;
  background-color: #f8f9fa;
}

.avatar {
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  background-color: #e0e0e0;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.avatar span#grupo img {
  width: 80%;
  height: 80%;
  object-fit: cover;
}

.nome-scroll {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}

.nome-scroll:hover {
  overflow-x: auto;
  text-overflow: unset; /* 👈 Remove os "..." no hover */
}

.nome-scroll::-webkit-scrollbar {
  height: 5px;
  background-color: transparent; /* Fundo invisível */
}

.nome-scroll::-webkit-scrollbar-thumb {
  background-color: #999;       /* Cor da alça de rolagem */
  border-radius: 4px;
}

.nome-scroll::-webkit-scrollbar-track {
  background-color: transparent; /* Fundo da trilha invisível */
}

.nome-e-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-grow: 1;
  min-width: 0; /* necessário para truncar corretamente */
}

.avatar-notificacao {
  outline: 2px solid var(--notificacao-verde);
  outline-offset: 2px;
  border-radius: 50%;
}

.btn-outline-blue {
    border-color: var(--sec-color);
    color: var(--sec-color);
}

.btn-outline-blue:hover {
    background-color: var(--sec-color);
    color: white;
}
</style>